import { render, staticRenderFns } from "./ProcessFlowForm.vue?vue&type=template&id=63f45c5e&"
import script from "./ProcessFlowForm.vue?vue&type=script&lang=js&"
export * from "./ProcessFlowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports